import React, { useMemo } from 'react';
import { allCountryMap } from '@opm/components/FilterCommon/constants/country';
import useIntls from '@opm/hooks/useIntls';
import CountryLabel, { CountryLabelProps } from '@opm/components/CountryLabel';

export default function CountryItem({
  country,
  className,
  showText = true,
  ...props
}: CountryLabelProps) {
  const { isEn } = useIntls();

  const text = useMemo(() => {
    return isEn ? allCountryMap.allText : allCountryMap.allTextCn;
  }, [isEn]);

  return (
    <CountryLabel
      country={country}
      showText={showText}
      newText={country === 'all' ? text : undefined}
      className={className} 
      {...props}
    />
  );
}
